/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagMapResponse } from '../../models/tag-map-response';
import { UpsertAssociationsRequest } from '../../models/upsert-associations-request';

export interface GetTagsBulk$Params {
  'Active-Tenant-Identifier': string;
  
    /**
     * Tag body
     */
    body?: UpsertAssociationsRequest
}

export function getTagsBulk(http: HttpClient, rootUrl: string, params: GetTagsBulk$Params, context?: HttpContext): Observable<StrictHttpResponse<TagMapResponse>> {
  const rb = new RequestBuilder(rootUrl, getTagsBulk.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagMapResponse>;
    })
  );
}

getTagsBulk.PATH = '/associations/entities_bulk';
